import React, { useState, useEffect } from "react";
import axios from 'axios';

const LiveActivityLogs = () => {
  const [logs, setLogs] = useState([]);
 
  const office_id = localStorage.getItem("office_id");
  const token = localStorage.getItem("token")

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://housys.skymarkone.in:8001/api/getlast10-entry-exits/${office_id}`,
          {
            headers: { Authorization: `Bearer ${token}`, },
          }
        );
        setLogs(response.data.data);
      } 
      catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div
      style={{
        minHeight: "570px",
        borderRadius: "20px",
        overflowX: "auto",
        background: "#ffffff",
        border: "1px solid #e9ecef",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
      }}
      className="p-4 mt-3"
    >
      {/* Header Section */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div className="d-flex align-items-center">
          <div 
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "15px",
              background: "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "15px"
            }}
          >
            <i className="bi bi-activity text-white" style={{ fontSize: "24px" }}></i>
          </div>
          <div>
            <h4 className="mb-0" style={{ 
              color: "#212529", 
              fontWeight: "700",
              fontSize: "1.5rem"
            }}>
              Live Activity Logs
            </h4>
          </div>
        </div>
        <div 
          style={{
            padding: "8px 16px",
            backgroundColor: "#e3f2fd",
            color: "#1565c0",
            borderRadius: "25px",
            fontSize: "0.85rem",
            fontWeight: "600"
          }}
        >
          <i className="bi bi-clock me-1"></i>
          Live Updates
        </div>
      </div>

      {/* Table Section */}
      <div 
        className="table-responsive"
        style={{
          borderRadius: "15px",
          overflow: "hidden",
          border: "1px solid #e9ecef"
        }}
      >
        <table className="table mb-0">
          <thead>
            <tr style={{ 
              background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
              borderBottom: "2px solid #dee2e6"
            }}>
                <>
                  <th style={{ 
                    textAlign: "center", 
                    padding: "18px 15px",
                    color: "#495057",
                    fontWeight: "700",
                    fontSize: "1rem",
                    border: "none"
                  }}>
                    <i className="bi bi-car-front me-2 text-primary"></i>
                    Vehicle Number
                  </th>
                  <th style={{ 
                    textAlign: "center", 
                    padding: "18px 15px",
                    color: "#495057",
                    fontWeight: "700",
                    fontSize: "1rem",
                    border: "none"
                  }}>
                    <i className="bi bi-credit-card me-2 text-warning"></i>
                    Card Number
                  </th>
                  <th style={{ 
                    textAlign: "center", 
                    padding: "18px 15px",
                    color: "#495057",
                    fontWeight: "700",
                    fontSize: "1rem",
                    border: "none"
                  }}>
                    <i className="bi bi-truck me-2 text-info"></i>
                    Vehicle Type
                  </th>
                  <th style={{ 
                    textAlign: "center", 
                    padding: "18px 15px",
                    color: "#495057",
                    fontWeight: "700",
                    fontSize: "1rem",
                    border: "none"
                  }}>
                    <i className="bi bi-box-arrow-in-right me-2 text-success"></i>
                    Entry Date & Time
                  </th>
                  <th style={{ 
                    textAlign: "center", 
                    padding: "18px 15px",
                    color: "#495057",
                    fontWeight: "700",
                    fontSize: "1rem",
                    border: "none"
                  }}>
                    <i className="bi bi-box-arrow-right me-2 text-danger"></i>
                    Exit Date & Time
                  </th>
                </>
             
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8f9fa",
                  transition: "all 0.3s ease"
                }}
                
                >
                 
                    <>
                      <td style={{ 
                        textAlign: "center",
                        padding: "16px 15px",
                        borderBottom: "1px solid #e9ecef",
                        color: "#212529",
                        fontWeight: "600"
                      }}>
                        <div className="d-flex align-items-center justify-content-center">
                          <span style={{
                            padding: "6px 12px",
                            color: "#0d6efd",
                            fontSize: "1rem"
                          }}>
                            {log.Vehicle?.vehicle_number || "N/A"}
                          </span>
                        </div>
                      </td>
                      <td style={{ 
                        textAlign: "center",
                        padding: "16px 15px",
                        borderBottom: "1px solid #e9ecef",
                        color: "#212529"
                      }}>
                        <span style={{
                          padding: "6px 12px",
                          color: "#856404",
                          fontSize: "1rem",
                          fontWeight: "600"
                        }}>
                          {log.Vehicle?.card_no || "N/A"}
                        </span>
                      </td>
                      <td style={{ 
                        textAlign: "center",
                        padding: "16px 15px",
                        borderBottom: "1px solid #e9ecef",
                        color: "#212529"
                      }}>
                        <span style={{
                          padding: "6px 12px",
                          color: log.Vehicle?.vehicle_type === "Car" ? "#155724" : "#004085",
                          borderRadius: "20px",
                          fontSize: "1rem",
                          fontWeight: "600"
                        }}>
                          
                          {log.Vehicle?.vehicle_type || "N/A"}
                        </span>
                      </td>
                      <td style={{ 
                        textAlign: "center",
                        padding: "16px 15px",
                        borderBottom: "1px solid #e9ecef",
                        color: "#212529",
                        fontSize: "1rem"
                      }}>
                        <div style={{
                          padding: "8px 12px",
                          color: "#0c5460",
                        }}>
                          {log.entry_datetime 
                            ? (() => {
                                const date = new Date(log.entry_datetime);
                                const day = String(date.getUTCDate()).padStart(2, '0');
                                const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                                const year = date.getUTCFullYear();
                                let hours = date.getUTCHours();
                                const minutes = String(date.getUTCMinutes()).padStart(2, '0');
                                const seconds = String(date.getUTCSeconds()).padStart(2, '0');
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                hours = hours % 12;
                                hours = hours ? hours : 12;
                                const hoursStr = String(hours).padStart(2, '0');
                                return `${day}/${month}/${year}, ${hoursStr}:${minutes}:${seconds} ${ampm}`;
                              })()
                            : "N/A"
                          }
                        </div>
                      </td>
                      <td style={{ 
                        textAlign: "center",
                        padding: "16px 15px",
                        borderBottom: "1px solid #e9ecef",
                        color: "#212529",
                        fontSize: "1rem"
                      }}>
                        <div style={{
                          padding: "8px 12px",
                          color: log.exits_timedate ? "#721c24" : "#6c757d",
                        }}>
                          {log.exits_timedate 
                            ? (() => {
                                const date = new Date(log.exits_timedate);
                                const day = String(date.getUTCDate()).padStart(2, '0');
                                const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                                const year = date.getUTCFullYear();
                                let hours = date.getUTCHours();
                                const minutes = String(date.getUTCMinutes()).padStart(2, '0');
                                const seconds = String(date.getUTCSeconds()).padStart(2, '0');
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                hours = hours % 12;
                                hours = hours ? hours : 12;
                                const hoursStr = String(hours).padStart(2, '0');
                                return `${day}/${month}/${year}, ${hoursStr}:${minutes}:${seconds} ${ampm}`;
                              })()
                            : "N/A"
                          }
                        </div>
                      </td>
                    </>
                 
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ 
                  textAlign: "center",
                  padding: "40px 20px",
                  color: "#6c757d",
                  backgroundColor: "#f8f9fa",
                  borderBottom: "none"
                }}>
                  <div>
                    <i className="bi bi-inbox" style={{ fontSize: "3rem", color: "#dee2e6", marginBottom: "15px" }}></i>
                    <h5 style={{ color: "#6c757d", fontWeight: "600" }}>No Data Available</h5>
                    <p className="mb-0" style={{ fontSize: "0.9rem" }}>
                      No activity logs found for the selected criteria.
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LiveActivityLogs;
